import { render, staticRenderFns } from "./stepEquipo.vue?vue&type=template&id=00f4003d&lang=pug"
import script from "./stepEquipo.vue?vue&type=script&lang=js"
export * from "./stepEquipo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports